module.exports = __webpack_public_path__ + "media/images/icon_list/link-41560aaa1e6decda716ad48699846cbb.svg";